export default "__VITE_ASSET__a6f6c364__"